import { AverageConsumptionQuality } from './AverageConsumption';
import { ConsumptionCalculationBase } from './ConumptionCalculationBase';
import { Iso8601DateTimeString } from './Iso8601DateTimeString';
import { ProductGroup } from './ProductGroup';
import { CategoryState } from './ReachInformationMessage';
import { SulphurContent } from './SulphurContent';

export interface DemandInformationStop {
    keyPort: boolean;
    currentPort: boolean;
    portLocode: string;
    scheduleId: string;
    categories: DemandInformationCategory[];
    eta: Iso8601DateTimeString;
    portName: string;
}

export interface DemandInformationLatestStocks {
    productGroup: ProductGroup;
    volume: number;
    dateCreated: Iso8601DateTimeString;
    sulphurContent: string;
}

interface DemandOfferItem {
    productId: string;
    tankCategory?: string;
    productGroup?: string;
    sulphurContent?: string;
}

export interface DemandInformationOfferPort {
    id: string;
    name: string;
    locode: string;
}

export interface DemandInformationOffers {
    id: string;
    port?: DemandInformationOfferPort | null;
    items: DemandOfferItem[];
}

export interface DemandInformationCategory {
    safetyReserve?: number;
    tankThreshold?: number;
    remainingVolume?: number;
    daysLeft?: number;
    averageDailyConsumption?: number;
    categoryName: string;
    sulphurContent: SulphurContent;
    productGroup: ProductGroup;
    categoryState?: CategoryState;
    maximumIntake?: number;
    tankCategory?: string;
    calculatedAverageDailyConsumption?: number;
    consumptionCalculationBase?: ConsumptionCalculationBase;
    qualityCategory?: AverageConsumptionQuality;
}

export enum VesselState {
    OPEN = 'OPEN',
    PLANNED = 'PLANNED',
    ORDERED = 'ORDERED',
}

export interface DemandInformationVessel {
    id: string;
    imo: string;
    name: string;
    email?: string;
    state: VesselState;
    categories: DemandInformationCategory[];
    stops: DemandInformationStop[];
    latestStocks: DemandInformationLatestStocks[];
    offers: DemandInformationOffers[];
    customerId: string;
}

export interface DemandInformationMessage {
    vessels: DemandInformationVessel[];
}
